import type { PresetDefinition } from './types'

export const cleanUpPresetSeo = (preset: PresetDefinition) => ({
  ...preset,
  pages: preset.pages.map(page => ({
    ...page,
    definition: {
      ...page.definition,
      data: {
        ...page.definition.data,
        advancedSeoData: undefined,
        pageTitleSEO: '',
        descriptionSEO: '',
        indexable: true,
      },
    },
  })),
})
